import { EnvService } from './../../env.service';
import { ButtonSetComponent } from './../button/button-set/button-set.component';
import { Component, OnInit, ViewChildren, QueryList, ContentChildren, ViewChild, EventEmitter, Output, AfterViewInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { ButtonComponent } from '../button/button.component';
export type SelectToolActionEvent = {
  selectAction: string;
  isOn?: boolean;
}
@Component({
  selector: 'app-select-tools',
  templateUrl: './select-tools.component.html',
  styleUrls: ['./select-tools.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectToolsComponent implements OnInit {
  private subcriptions: SubScriptionMgr = new SubScriptionMgr();
  public selectedAction: string;

  // tslint:disable-next-line: variable-name
  @ViewChild('buttonSet', { static: true }) buttonSet: ButtonSetComponent;
  private _hasResults: boolean = false;
  @Input() set hasResults(isTrue: boolean) {
    this._hasResults = isTrue;
    this.Refresh();
  }
  get hasResults(): boolean {
    return this._hasResults;
  }
  @Output() actions = new EventEmitter<SelectToolActionEvent>();
  @Input() btnSize = 'md';
  private _ready = false;

  public get isSLViewer() {
    return (this.env.GetAppNameFromURL(true) === 'sl-viewer');
  }
  public get hidePucButton() {
    if(!this.hasResults) return true;
    if(this.isSLViewer) return true;
    return false;
  }

  constructor(private cdr: ChangeDetectorRef, private env: EnvService) { }

  ngOnInit() {
    this._ready = true;
    /*this.subcriptions.Subscribe(this.currentMode_btn.ready, () => {
      this.SelectButton({}, 1, false);
      this.currentMode_btn.ChangeMode('secondary');
    });*/

  }

  UpdateHeight() {
    this.buttonSet.UpdatePosition();
    this.Refresh();
  }

  /*SelectButton(event, i, notify: boolean = true) {
    if (event.hasOwnProperty('preventDefault')) {
      event.preventDefault();
    }
    if (event.hasOwnProperty('stopImmediatePropagation')) {
      event.stopImmediatePropagation();
    }

    this.SelectButtonN(i, notify);
  }*/
  /*SelectButtonN(n: number, triggerAction: boolean = true) {
    const buttons = this.currentMode_btn.GetDropDownButtons();
    if(n > buttons.length) return;
    if (this.selectedAction === buttons[n].function) {
      return;
    }
    (buttons[0] as IconButtonComponent).ChangeIcon(
      (buttons[n] as IconButtonComponent).icon
    );
    (buttons[0] as IconButtonComponent).ChangeMode(
      'secondary-' + (buttons[n] as IconButtonComponent).mode
    );
    this.selectedAction = buttons[n].function;
    if (triggerAction) { this.PerformAction(); }
  }*/
  /*PerformAction() {
    this.actions.emit({ selectAction: this.selectedAction });
  }*/
  SelectTool(action: string, isOn?: boolean) {
    let ctr = 0;
    if (isOn === undefined) isOn = true;
    if (isOn === true) {
      this.buttonSet.buttons.toArray().every((button: ButtonComponent) => {
        if (button.buttonName !== action) {
          if (button.isToggleable === true) {
            button.Toggle(false);
            ctr++;
          }
        }
        return true;
      });
    } else {
      action = 'navigation';
    }
    this.actions.emit({ selectAction: action });
    this.Refresh();
  }
  Reset() {
    if (!this.buttonSet.buttons?.length) return;
    this.buttonSet.buttons.get(0).Toggle(true);
    this.Refresh();

  }
  Refresh() {
    this.cdr.markForCheck();
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
}
